import {useState, useContext, useEffect} from "react";
import axios from 'axios'
import {toast} from 'react-hot-toast'
import {useNavigate, Link} from 'react-router-dom'
import{UserContext} from '../../context/userContext/userContext';
import { useStyle } from "../../context/styleContext/styleContext";
import ReactGA from 'react-ga4';
import TermsModal from "../Terms/TermsModal"
import Terms from "../Terms/Terms";
import Button from '@mui/material/Button';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Checkbox, TextField, FormCOntrol, InputLabel, OutlinedInput, InputAdornment, FormControl, IconButton, FormGroup, FormControlLabel } from "@mui/material";


export default function Login(){
    const navigate = useNavigate()
    const [isModalOpen, setModalOpen] = useState(false);
    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);
    const { style, setStyle } = useStyle();
    const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
    
    ReactGA.send({
        hitType:"pageview",
        page:"login",
        title:"login",
      })

  
      useEffect(() => {
      document.title = 'Parish Audio | Cutting-Edge Audio Processing | | Login';
  }, []);

    const[data,setData] = useState({
        email: '',
        password: ''
    })

    const navToRegister = () => {
        navigate('/register')
      }

    const { setUser } = useContext(UserContext);
    const { isLoading,  } = useContext(UserContext);
    const { setUpdateFlag } = useContext(UserContext);


    const wait = (n) => new Promise((resolve) => setTimeout(resolve, n));

    // 
    
    const loginUser = async (e) => {
      e.preventDefault();
  
      const { email, password } = data;
  
      try {
          const { data } = await axios.post('/login', {
              email,
              password
          });
  
          if (data.error) {
              toast.error(data.error);
          } else {
              toast.success("Login successful, welcome!");
              localStorage.setItem('token', data.token);
              await setUser(data);
              //window.location.href = `/`;
              navigate('/');
              
          }
      } catch (error) {
          // Handle Axios error response
          if (error.response && error.response.data && error.response.data.error) {
              toast.error(error.response.data.error);
          } else {
              toast.error("An unexpected error occurred while logging in.");
          }
      }
  };

    return(
        <><>
        <div style={{display:'flex', flexDirection:'column', width:'100%', marginBottom:'25px'}}>

<div style={{display:'flex', flexDirection:'column', width:'90%', maxWidth:'600px', margin:'auto', color:style.color4, textAlign:'center', marginTop:'25px', backgroundColor:style.color1, borderRadius:'10px', borderStyle:'solid', borderColor:style.color1, borderWidth:'5px'}}>
    <div style={{width:'90%', margin:'auto'}}>

    
        <div style={{display:'flex', flex:1, textAlign:'center', marginTop:'25px'}}>
            <h1 style={{flex:1, textAlign:'center', margin:'auto', marginBottom:'20px', marginTop:'10px', fontSize:'2.0em'}}>
                Login to your account
            </h1>
           
        </div>
        <div style={{maxWidth:'400px', margin:'auto'}}>
        <div style={{display:'flex', flex:1, textAlign:'center', minWidth:'300px', margin:'auto', marginBottom:'10px'}}>
            <h4 style={{flex:1, textAlign:'left', margin:'auto', color:style.color1}}>
                <div style={{marginBottom:'5px'}}>
                <TextField
                id="outlined-basic"
                label="Email"
                variant="outlined"
                value= {data.firstName}
                onChange={(e) => setData({...data, email: e.target.value})}
                size='small'
                fullWidth
                sx={{
                    backgroundColor: style.color2,
                    borderRadius:'4px',
                    '& .MuiInputBase-input': {
                    color: style.color4,  // Change the font color here
                    fontSize: '16pt',  // Change the font size here
                    boxShadow:5,
                                                    
                    },
                    '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                        borderColor: style.color1, // Change the border color if needed
                        borderWidth:'2px'
                    },
                    '&:hover fieldset': {
                        borderColor: style.color1, // Change the border color on hover if needed\
                        borderWidth:'3px',                                                               
                 
                        
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: style.color1, // Change the border color when focused if needed
                        borderWidth:'3px'
                        
                    },
                    '&.Mui-disabled': {
                        '& fieldset': {
                        borderColor: style.color1, // Change the border color when disabled
                        },
                    },
                    },
                    '& .MuiInputLabel-root': {
                    color: style.color3, // Change the label color here
                    fontSize:'14pt',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                    color: style.color3, // Change the label color when focused here                                 
                    },
                    '& .MuiInputLabel-root.Mui-disabled': {
                    color: style.color2, // Change the label color when disabled
                    },
                    '& .MuiInputBase-root.Mui-disabled': {
                    '& input': {
                        color: style.color3, // Change the input font color when disabled // so it works in safari
                        WebkitTextFillColor: style.color4, // so it works on chrome
                        fontSize:'14pt'
                    },
                    },
                    '& .MuiOutlinedInput-input': { color: style.color4,
                    '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset',
                        WebkitTextFillColor: style.color4, color:style.color4
                     }, }, 
                }}
                />
                

                </div>
                </h4>
        </div>

        <div style={{display:'flex', flex:1, marginBottom:'10px', width:'100%', backgroundColor:style.color1}}>     

            <FormControl sx={{
                  backgroundColor: style.color2,
                  flex: 1,
                  width:'100%',
                  size: 'small',
                  margin: 'auto',
                  boxShadow:5,
                  

                  '& .MuiInputBase-input': {
                    color: style.color3,
                    fontSize: '14pt',
                    size: 'small',
                  },
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: style.color1,
                      borderWidth: '2px'
                    },
                    '&:hover fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: style.color2,
                      borderWidth: '3px',
                    },
                    '&.Mui-disabled': {
                      '& fieldset': {
                        borderColor: style.color1,
                      },
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: style.color3,
                    fontSize: '14pt',
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: style.color3,
                  },
                  '& .MuiInputLabel-root.Mui-disabled': {
                    color: style.color3,
                  },
                  '& .MuiInputBase-root.Mui-disabled': {
                    '& input': {
                      color: style.color3,
                      WebkitTextFillColor: style.color1,
                      fontSize: '14pt'
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    color: style.color4,
                    '& input:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                    WebkitTextFillColor: `${style.color4} !important`,
                    color: `${style.color4} !important`,
                    caretColor: `${style.color4} !important`,
                },
                  },
                }} variant="outlined">
                  <InputLabel size="small" htmlFor="outlined-adornment-password">Password</InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    value={data.password}
                    size='small'
                    onChange={(e) => setData({...data, password: e.target.value})}
                    sx={{
                        '& input:-webkit-autofill': {
                        WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset !important',
                        WebkitTextFillColor: `${style.color4} !important`,
                        color: `${style.color4} !important`,
                        caretColor: `${style.color4} !important`,
                        
                    },
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          sx={{ color: style.color1 }}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    label="Password"
                  />
  
                 </FormControl>
                          
                        </div>
                        <div >
                          <Link to='/forgot-password' style={{fontSize:'.9em', marginTop:'10px', fontWeight:'bold', textAlign:'center', color:style.color4, margin:'auto', alignContent:'center'}}>
                              Forgot Password?
                        </Link>
                          </div>
       

        

        {(data.email && data.password ) &&(
        <div style={{marginTop:'25px', marginBottom:'50px', display:'flex', flex:1}}>
            <Button onClick={loginUser}  sx={{ my: 2, color: style.color4, display: 'block', backgroundColor: style.color1, filter: 'brightness(1.1)', boxShadow:5,fontSize: '14pt', width: '75%', minWidth: '250px', margin: 'auto', marginTop: '0px', borderColor: style.color2, borderWidth: '1px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color2 }, }}>Login</Button>
        </div>
        )}
        {(!data.email || !data.password ) &&(
        <div style={{marginTop:'25px', marginBottom:'50px', display:'flex', flex:1}}>
            <Button disabled onClick={loginUser} sx={{ my: 2, color:style.color2, display:'block', backgroundColor:style.color1, fontSize:'14pt', width:'75%', margin:'auto', marginTop:'0px', borderColor:style.color2, borderWidth:'1px', borderStyle:'solid', '&:hover': {backgroundColor: style.color4 }, }}><span style={{color:style.color3}}>Login</span></Button>
        </div>
        )} 

        <div style={{marginBottom:'30px'}}>
            <h4>Not yet a member? Join for free!</h4>

            <Button size='small' onClick={navToRegister} sx={{ my: 2, color: style.color3, display: 'block', margin: 'auto', boxShadow:5,backgroundColor: style.color1, filter: 'brightness(1.1)', fontSize: '12pt', width: '75%', minWidth: '150px', margin: 'auto', marginTop: '0px', borderColor: style.color2, borderWidth: '1px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color2 } }}>
               <strong>Create Account</strong>
            </Button>


            </div>
            <div style={{ flex:1, borderBottomLeftRadius:'15px', color:style.color5, marginBottom:'10px'}}>                 
                    By using this website, you agree to our 
                    <div>
                        <Button size='small' sx={{ my: 2, color: style.color3, display: 'block', margin: 'auto', backgroundColor: style.color1, fontSize: '12pt', width: '100%', minWidth: '250px', margin: 'auto', marginTop: '0px', borderColor: style.color1, borderWidth: '2px', borderStyle: 'solid', '&:hover': { backgroundColor: style.color1, color:style.color4 } }} onClick={setModalOpen.bind(null, true)}><strong>terms and conditions</strong></Button>
                    </div>
                    </div>

                    <div id='modal-root'>
                    <TermsModal isOpen={isModalOpen} close={closeModal}>
                        <Terms />
                    </TermsModal>
                    </div>
            
                </div>                




    </div>

    </div>

</div>
<div id='modal-root'>
</div>


        </>
        </>         

    )

    
}

